import { TECHNICAL_COMMUNICATION_COURSES } from './technical-communication';
import { CAREER_ADVANCEMENT_COURSES } from './career-advancement';
import { REMOTE_WORK_EXCELLENCE_COURSES } from './remote-work-excellence';
import { INNOVATION_PROBLEM_SOLVING_COURSES } from './innovation-problem-solving';

// Professional development courses for internal training
export interface ProfessionalDevelopmentCourse {
  id: string;
  title: string;
  description: string;
  level: string;
  totalDuration: string;
  image: string;
  prerequisites: string[];
  learningOutcomes: string[];
  modules: any[];
}

export const PROFESSIONAL_DEVELOPMENT_COURSES = [
  ...TECHNICAL_COMMUNICATION_COURSES,
  ...CAREER_ADVANCEMENT_COURSES,
  ...REMOTE_WORK_EXCELLENCE_COURSES,
  ...INNOVATION_PROBLEM_SOLVING_COURSES,
];

export {
  TECHNICAL_COMMUNICATION_COURSES,
  CAREER_ADVANCEMENT_COURSES,
  REMOTE_WORK_EXCELLENCE_COURSES,
  INNOVATION_PROBLEM_SOLVING_COURSES,
};